/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpinWheelResponseWinningOutcome
 */
export interface SpinWheelResponseWinningOutcome {
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWinningOutcome
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWinningOutcome
     */
    color?: string;
    /**
     * 
     * @type {number}
     * @memberof SpinWheelResponseWinningOutcome
     */
    outcomeIndex?: number;
}

/**
 * Check if a given object implements the SpinWheelResponseWinningOutcome interface.
 */
export function instanceOfSpinWheelResponseWinningOutcome(value: object): value is SpinWheelResponseWinningOutcome {
    return true;
}

export function SpinWheelResponseWinningOutcomeFromJSON(json: any): SpinWheelResponseWinningOutcome {
    return SpinWheelResponseWinningOutcomeFromJSONTyped(json, false);
}

export function SpinWheelResponseWinningOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelResponseWinningOutcome {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'color': json['color'] == null ? undefined : json['color'],
        'outcomeIndex': json['outcomeIndex'] == null ? undefined : json['outcomeIndex'],
    };
}

export function SpinWheelResponseWinningOutcomeToJSON(json: any): SpinWheelResponseWinningOutcome {
    return SpinWheelResponseWinningOutcomeToJSONTyped(json, false);
}

export function SpinWheelResponseWinningOutcomeToJSONTyped(value?: SpinWheelResponseWinningOutcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'color': value['color'],
        'outcomeIndex': value['outcomeIndex'],
    };
}

